export const LogoFull = () => (
  <span className="studio-logo">inShift <em>Studio</em></span>
);
